(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__customFooterAccordionBound) return;
  window.__customFooterAccordionBound = true;
  document.addEventListener('click', function (event) {
    var heading = event.target.closest('.custom-footer__menu-heading');
    if (!heading) return;
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var column = heading.closest('.custom-footer__menu-column');
    if (column) column.classList.toggle('is-open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
